import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutMinerId: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      fill={colors['--pink-500']}
      fillRule="evenodd"
      d="M25.163 32.069a2.49 2.49 0 002.5 2.48h1.998c1.38 0 2.5-1.11 2.5-2.48V29.96a2.49 2.49 0 00-2.5-2.48h-1.999a2.49 2.49 0 00-2.499 2.48v2.108zM47.84 32.069a2.49 2.49 0 002.499 2.48h1.999c1.38 0 2.499-1.11 2.499-2.48V29.96a2.49 2.49 0 00-2.5-2.48H50.34a2.49 2.49 0 00-2.5 2.48v2.108z"
      clipRule="evenodd"
    />
    <path
      fill={colors['--pink-500']}
      fillRule="evenodd"
      d="M56.836 22.454c1.38 0 2.5 1.11 2.5 2.48v1.984a2.49 2.49 0 002.498 2.48h1.625c1.38 0 2.499 1.11 2.499 2.48v9.052a2.49 2.49 0 01-2.5 2.48H46.216a2.49 2.49 0 00-2.499 2.48v2.232a2.49 2.49 0 002.5 2.48h17.243c1.38 0 2.499 1.11 2.499 2.48v1.984a2.49 2.49 0 01-2.5 2.48H45.716a2.49 2.49 0 01-2.499-2.48v-1.984a2.49 2.49 0 00-2.499-2.48h-1.5a2.49 2.49 0 01-2.498-2.48V24.934a2.49 2.49 0 012.499-2.48h17.618zm2.125 11.532a2.49 2.49 0 01-2.5 2.48H46.215a2.49 2.49 0 01-2.499-2.48v-2.108a2.49 2.49 0 012.5-2.48H56.46c1.38 0 2.5 1.11 2.5 2.48v2.108z"
      clipRule="evenodd"
    />
    <path
      fill={colors['--pink-500']}
      fillRule="evenodd"
      d="M23.164 22.454a2.49 2.49 0 00-2.5 2.48v1.984a2.49 2.49 0 01-2.498 2.48H16.54a2.49 2.49 0 00-2.499 2.48v9.052a2.49 2.49 0 002.5 2.48h17.243c1.38 0 2.5 1.11 2.5 2.48v2.232a2.49 2.49 0 01-2.5 2.48H16.541a2.49 2.49 0 00-2.499 2.48v1.984a2.49 2.49 0 002.5 2.48h17.743c1.38 0 2.499-1.11 2.499-2.48v-1.984a2.49 2.49 0 012.499-2.48h1.5c1.38 0 2.499-1.11 2.499-2.48V24.934a2.49 2.49 0 00-2.5-2.48H23.165zM21.04 33.986a2.49 2.49 0 002.499 2.48h10.246c1.38 0 2.5-1.11 2.5-2.48v-2.108a2.49 2.49 0 00-2.5-2.48H23.54a2.49 2.49 0 00-2.5 2.48v2.108z"
      clipRule="evenodd"
    />
    <path stroke={colors['--pink-500']} strokeWidth="3" d="M1.5 1.5H78.5V78.5H1.5z" />
  </svg>
);

export default AboutMinerId;
